module.exports = __webpack_public_path__ + "images/interview-Bayer-2.svg";